import axios from 'axios'
import baseURL from '@/plugins/http/baseURL'
import Loading from 'vue-loading-overlay'

export default {
  data: function () {
    return {
      actions: false,
      isLoading: false,
      onCancel: true,
      fullPage: true
    }
  },
  props: {
    accountability: {
      type: Object,
      require: true
    }
  },
  components: {
    Loading
  },
  methods: {
    forceFileDownload (response, accountability) {
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', accountability.description.replace(/\s/g, '') + '.pdf')
      document.body.appendChild(link)
      link.click()
    },
    downloadFile (accountability) {
      this.isLoading = true
      axios({
        method: 'post',
        url: baseURL + '/v1/dweller/accountability/download',
        data: {id: accountability.files[0].id},
        responseType: 'arraybuffer'
      })
      .then(response => {
        this.forceFileDownload(response, accountability)
        this.isLoading = false
      })
      .catch(() => {
        this.$toast.error('Arquivo não pode ser localizado.')
        this.isLoading = false
      })
    },
    viewActions (status) {
      if (status) {
        this.actions = false
      } else {
        this.actions = true
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/dweller/accountability/index/components/resources/index.js